export const queryKeys = {
  boxes: ["boxes"] as const,
  boxDetails: (boxId: string) => ["boxes", boxId] as const,
  collections: ["collections"] as const,
  dex: ["dex"] as const,
  dexDetails: (setId: string) => ["dex", setId] as const,
  leaderboard: ["leaderboard"] as const,
  pokeTeams: ["poke-teams"] as const,
  inventoryItems: ["inventory-items"] as const,
  itemDecks: ["item-decks"] as const,
  inventoryItemCards: ["inventory-item-cards"] as const,
  inventoryEnergy: ["inventory-energy"] as const,
  trainingStatus: ["training-status"] as const,
  inventoryPokemons: ["inventory-pokemons"] as const,
  packs: ["packs"] as const,
  shopRotation: ["shop-rotation"] as const,
  friends: ["friends"] as const,
  lfgLobbies: ["lfg-lobbies"] as const,
  feed: ["feed"] as const,
  siegeMapClears: ["siege-map-clears"] as const,
};
